import { AxiosResponse } from "axios";
import { toast } from "react-hot-toast";
import { call, put, select, takeLatest } from "redux-saga/effects";
import { AppService } from "src/services/app";
import { getBaseUrl } from "../selectors/features/app";
import {
  createCompanyFailure,
  createCompanySuccess,
} from "../slices/features/createCompany";
import { RequestTypes } from "../types";

const updateCompanyService = new AppService();

function* createCompany(action: any) {
  try {
    const baseUrl: string = yield select(getBaseUrl);

    const response: AxiosResponse<any> = yield call(
      updateCompanyService.createCompany,
      baseUrl,
      action.payload
    );

    toast.success("Company create successfully!");

    yield put(createCompanySuccess({ ...response }));
  } catch (error: any) {
    const { statusCode, statusText } = error;

    const {
      data: {
        errors: { message },
      },
    } = error;

    toast.error(Array.isArray(message) ? message[0] : message);

    yield put(createCompanyFailure({ statusCode, statusText }));
  }
}

export function* watchCreateCompany() {
  yield takeLatest(RequestTypes.CREATE_COMPANY, createCompany);
}
